if (!customElements.get('pdp-layout')) {
  customElements.define(
    'pdp-layout',
    class PdpLayout extends HTMLElement {
      // Desktop keeps `.product__media-tabs` nested inside `.product__media-wrapper`
      // (under the gallery) so that column's height gives `.pdp-info.sticky-element`
      // room to stay pinned while scrolling -- see component-main-product-pdp.css.
      // Mobile instead wants the tabs below all other info (title/price/buy box),
      // so this moves the tabs node itself, not a clone, to the end of `.product`.
      // `pdp-layout` (this element, aliasing `.product`) never moves, so this only
      // runs once and avoids the connected/disconnected churn a moved custom
      // element would trigger.
      connectedCallback() {
        const tabs = this.querySelector('.product__media-tabs');
        if (!tabs) return;

        const anchor = tabs.previousElementSibling;
        const mediaWrapper = tabs.parentElement;
        const mql = window.matchMedia('(max-width: 767.98px)');
        const sync = () => {
          if (mql.matches) {
            this.appendChild(tabs);
          } else if (anchor) {
            anchor.after(tabs);
          } else {
            mediaWrapper.prepend(tabs);
          }
        };
        mql.addEventListener('change', sync);
        sync();
      }
    }
  );
}
